export const templateUrlConfigJck = {
  jckla: './jckla-editPkg.component.html',
  jcktl: './jcktl-editPkg.component.html',
}
export * from './service/jcktk.service';
export * from './service/jckla.service';
export * from './service/jcktl.service';
//export * from './service/jcksm.service';


